export default "__VITE_ASSET__M2268N7U__"